export const BROWSER_ATTRIBUTES = {
  PLATFORM: 'browser.platform',
  BRANDS: 'browser.brands',
  MOBILE: 'browser.mobile',
  LANGUAGE: 'browser.language',
  USER_AGENT: 'browser.user_agent'
};
